import React, { createContext, useContext, useState, ReactNode } from "react"
import {
    MeetingServiceFilterProps,
    defaultMeetingServiceFilterOptionsList,
} from "../../../../../supplier/reporting/accounting/meetingService/components/FiltersDrawerMeetingService"
import { useInitialDateFilters } from "../../../../../../shared/components/table/useInitialDateFilters"
import { useMerchant } from "../../../../../merchants/merchantHooks"
import useActiveFiltersCount from "../../../../../supplier/reporting/accounting/meetingService/hooks/useActiveFiltersCount"

type MeetingServiceFiltersContextType = {
    filtersList: MeetingServiceFilterProps
    setFiltersList: React.Dispatch<React.SetStateAction<MeetingServiceFilterProps>>
    activeCount: number
    search: string
    setSearch: (value: string) => void
}

export const meetingServiceDisabledFilters = {
    disableDeliveryDate: true,
    disableInvoicing: true,
    disablePendingApproval: true,
    disableMerchantShops: true,
    disableServicePayment: true,
}

const MeetingServiceFiltersContext = createContext<MeetingServiceFiltersContextType | undefined>(undefined)

export function MeetingServiceFiltersProvider({ children }: { children: ReactNode }) {
    const { merchantId } = useMerchant()
    const { startDate, endDate } = useInitialDateFilters()

    const [filtersList, setFiltersList] = useState<MeetingServiceFilterProps>(() => ({
        ...defaultMeetingServiceFilterOptionsList,
        merchantId: merchantId.toString(),
        startDeliveryDate: startDate,
        endDeliveryDate: endDate,
    }))
    const [search, setSearch] = useState("")

    const { activeCount } = useActiveFiltersCount(filtersList, meetingServiceDisabledFilters)

    return (
        <MeetingServiceFiltersContext.Provider value={{ filtersList, setFiltersList, activeCount, search, setSearch }}>
            {children}
        </MeetingServiceFiltersContext.Provider>
    )
}

export function useMeetingServiceFilters() {
    const context = useContext(MeetingServiceFiltersContext)
    if (context === undefined) {
        throw new Error("useMeetingServiceFilters must be used within MeetingServiceFiltersProvider")
    }
    return context
}
